function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("ellipse", {
  cx: 25.924,
  cy: 25.906,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  rx: 6.652,
  ry: 6.716
}), React.createElement("ellipse", {
  cx: 25.924,
  cy: 25.005,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  rx: 2.758,
  ry: 2.785
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M29.98 31.23a3.183 3.183 0 0 0-3.164-3.195h-2.028c-1.622 0-2.92 1.31-2.92 2.949M25.818 18.99l-.044-2.954"
}), React.createElement("ellipse", {
  cx: 25.879,
  cy: 13.601,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  rx: 2.392,
  ry: 2.415
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M25.756 32.767v2.567"
}), React.createElement("ellipse", {
  cx: 25.879,
  cy: 38.12,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  rx: 2.392,
  ry: 2.415
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M19.44 29.322l-1.84 1.244"
}), React.createElement("ellipse", {
  cx: 15.453,
  cy: 32.114,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  rx: 2.392,
  ry: 2.415
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M32.318 22.23l1.718-1.509"
}), React.createElement("ellipse", {
  cx: 36.305,
  cy: 19.607,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  rx: 2.392,
  ry: 2.415
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M32.318 29.322l1.84 1.244"
}), React.createElement("ellipse", {
  cx: 36.305,
  cy: 32.114,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  rx: 2.392,
  ry: 2.415
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M19.44 22.23l-1.718-1.509"
}), React.createElement("ellipse", {
  cx: 15.453,
  cy: 19.607,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  rx: 2.392,
  ry: 2.415
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 51 51",
    stroke: "currentColor"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-influencer-list.366e3040.svg";
export { SvgComponent as ReactComponent };